import { Construction, GraduationCap, PawPrint, HeartPulse, Zap, Trash2, LayoutGrid } from "lucide-react";

export const CATEGORIES = [
  { key: "roads", label: "Roads", icon: Construction, color: "#FF9933" },
  { key: "schools", label: "Schools", icon: GraduationCap, color: "#38BDF8" },
  { key: "stray_animals", label: "Stray Animals", icon: PawPrint, color: "#A78BFA" },
  { key: "health", label: "Health", icon: HeartPulse, color: "#F43F5E" },
  { key: "electricity", label: "Electricity", icon: Zap, color: "#EAB308" },
  { key: "garbage", label: "Garbage", icon: Trash2, color: "#138808" },
];

export const ALL_TAB = { key: "all", label: "All Issues", icon: LayoutGrid, color: "#F1F5F9" };

export const CATEGORY_MAP = Object.fromEntries(CATEGORIES.map((c) => [c.key, c]));

export const STATUS_MAP = {
  reported: { label: "Reported", color: "#94A3B8" },
  under_review: { label: "Under Review", color: "#EAB308" },
  resolution_proposed: { label: "Resolution Proposed", color: "#38BDF8" },
  solved: { label: "Solved", color: "#138808" },
};

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  if (s < 604800) return `${Math.floor(s / 86400)}d ago`;
  return d.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
}
